import { createFileRoute, Link } from '@tanstack/react-router';
import PageGray from '../../../components/General/PageGray';
import H1 from '../../../components/Typography/Headings/H1';
import { useTranslation } from 'react-i18next';
import { Icon } from '@testbusters/icon';
import Span from '../../../components/Typography/Span';
import { SubjectChart } from '../../../components/Charts/SubjectChart';
import { Card } from '@testbusters/card';
import H3 from '../../../components/Typography/Headings/H3';
import { useGetStats } from '../../../hooks/profile/useStats';

export const Route = createFileRoute('/_sidebar/statistiche/materie')({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation();
  const { brandStats: stats } = useGetStats();

  const subjectsStats = (stats?.bySubject ?? []).map((subject) => {
    const total = (subject.correct ?? 0) + (subject.wrong ?? 0) + (subject.empty ?? 0);
    return {
      ...subject,
      percentage: total > 0 ? Math.round(((subject.correct ?? 0) / total) * 100) : 0,
    };
  });

  const sorted = [...subjectsStats].sort((a, b) => b.percentage - a.percentage);

  return (
    <PageGray className="flex flex-col gap-8">
      <div className="flex gap-4">
        <Link
          to="/statistiche"
          className="h-fit"
        >
          <Icon
            name="chevron-left"
            className="text-4xl"
          ></Icon>
        </Link>
        <div className="flex flex-col">
          <H1>{t('subjects.title')}</H1>
          <Span>{t('subjects.subtitle')}</Span>
        </div>
      </div>
      <Card className="flex flex-col gap-7 p-7 shadow-none bg-white">
        <H3>{t('subjects.subjectAnswers')}</H3>
        <SubjectChart subjects={sorted} />
      </Card>
    </PageGray>
  );
}
